module.exports = __webpack_public_path__ + "static/media/header.be74857b.jpg";